import React from 'react'

function Accessories() {
  return (
    <div>
    <br/> <br/>
    <h1>thes is Accessories page</h1>
    </div>
  )
}

export default Accessories